import {UI} from "../../../stem-core/src/ui/UIBase.js";

import {BasePanelPage} from "../PanelPage.jsx";
import {AuthFlowPanel} from "../../common/auth/AuthFlowPanel.jsx";


export class AuthPanelPage extends BasePanelPage {
    getFlowOptions() {}

    render() {
        return <AuthFlowPanel {...this.getFlowOptions()} />
    }
}
